import * as React from "react";
import ResizeObserver from "resize-observer-polyfill";
import { useCallbackRef } from "./use-callback-ref";
export function useMeasure(ref) {
    var _a = useCallbackRef(), element = _a[0], attachRef = _a[1];
    // unsure if this would be better defaulting to null. I think
    // in practice it's easier to just use default values of 0
    var _b = React.useState({
        left: 0,
        height: 0,
        top: 0,
        width: 0,
        bottom: 0,
        x: 0,
        y: 0,
        right: 0
    }), bounds = _b[0], setBounds = _b[1];
    // bind resize handler
    React.useEffect(function () {
        function onResize(_a) {
            var entry = _a[0];
            setBounds(entry.contentRect);
        }
        var observer = new ResizeObserver(onResize);
        if (element && element.current) {
            observer.observe(element.current);
        }
        return function () {
            observer.disconnect();
        };
    }, [element]);
    // attach our ref
    React.useEffect(function () {
        attachRef(ref);
    }, []);
    return { bounds: bounds };
}
